import { Component, ElementRef, Input, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { format, subYears } from 'date-fns';

@Component({
  selector: 'inputb3',
  template: `
    <div [class]="mainClass + ' ' + extraClass + ' ' + fInputType">
      <label [for]="fID" class="label-b3">{{ fPlaceholder }}</label>

      <div [class]="'input-container ' + fInputType">
        <input
          *ngIf="fInputType !== 'checkbox'"
          [class]="'formType_' + fInputType"
          [type]="fInputType === 'password' ? (showPassword ? 'text' : 'password') : fInputType"
          [min]="fMinVal"
          [max]="fMaxVal"
          [id]="fID"
          [name]="fID"
          [required]="isRequired"
          [(ngModel)]="formValue"
          (ngModelChange)="handleChange($event)"
          [autocomplete]="fAutoComplete"
          (click)="onTouched()"
          [disabled]="disabled"
          [placeholder]="placeholder" />

        <input
          *ngIf="fInputType === 'checkbox'"
          [class]="'formType_' + fInputType"
          [type]="fInputType"
          [id]="fID"
          [name]="fID"
          (change)="handleChange($event.target.checked)"
          [required]="isRequired"
          [ngModel]="formValue"
          [disabled]="disabled" />
        <div *ngIf="fInputType === 'password'" class="show-hide d-flex" (click)="toogleShowPassword()">
          <image-loader-utils [url]="showPassword ? 'eye-visible' : 'eye-hidden'" extraClasses="m-auto input-icon"></image-loader-utils>
        </div>
        <div *ngIf="fSuffixText !== ''" class="show-hide d-flex">
          <p>{{ fSuffixText }}</p>
        </div>
      </div>
      <div class="error-b3" *ngIf="showError">
        {{ fErrorText }}
      </div>
    </div>
  `,
})
export class InputB3 implements ControlValueAccessor {
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: any;

  touched = false;

  private errorMessages = new Map<string, () => string>();
  mainClass = 'form-b3 form-field-b3';

  @Input()
  extraClass = '';
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType: 'text' | 'password' | 'number' | 'checkbox' = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  fSuffixText = '';

  @Input()
  fMinVal: string;
  @Input()
  fMaxVal: string;
  @Input()
  placeholder = '';
  showPassword = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(change: any) {
    this.onTouched();

    if (this.fInputType === 'number') {
      const fMin = parseInt(this.fMinVal);
      const fMax = parseInt(this.fMaxVal);
      const changeVal = parseInt(change);

      this.onChanged(this.formValue);
      if (fMin || fMax) {
        if (fMin && fMin >= changeVal) {
          this.formValue = fMin;
        }

        if (fMax && fMax < changeVal) {
          this.formValue = fMax;
        }
      }
      this.onChanged(this.formValue);
    } else {
      this.onChanged(change);
    }
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }

  toogleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}

@Component({
  selector: 'dropdownb3',
  template: `
    <div class="form-b3 form-field-b3" (click)="onTouched()">
      <label class="label-b3" *ngIf="fPlaceholder !== ''">{{ fPlaceholder }}:</label>
      <div class="dropdown">
        <button
          #dropdownMain
          type="button"
          tabindex="0"
          [class]="'dropdown-toggle buttonD ' + (formValue !== '' ? 'selected' : 'not-selected')"
          aria-expanded="false"
          (click)="toogleMenuOpen()">
          <span> {{ showValue() }} </span>
        </button>
        <div
          outsideListener
          (clickOutside)="handleOutside($event)"
          aria-labelledby="langIdDropdown"
          aria-haspopup="true"
          [ngClass]="{ 'dropdown-menu': true, show: isMenuOpen }"
          x-placement="bottom-left"
          style="position: absolute; top: 0px; left: 0px; will-change: transform; transform: translate(0px, 33px);">
          <button *ngFor="let x of fData" type="button" [class]="'dropdown-item py-2' + ' ' + fextraClass" (click)="writeValue(x[fDataValueKey])">
            {{ x[fDataViewKey] }}
          </button>
        </div>
        <div class="error-b3" *ngIf="showError">
          {{ fErrorText }}
        </div>
      </div>
    </div>
  `,
})
export class Dropdownb3 implements ControlValueAccessor {
  @ViewChild('dropdownMain', { static: true })
  dropdownMain: ElementRef<HTMLInputElement>;

  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: string;

  touched = false;

  isMenuOpen = false;

  private errorMessages = new Map<string, () => string>();
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  fData = [];
  @Input()
  fDataValueKey = '';
  @Input()
  fDataViewKey = '';
  @Input()
  fDefaultSelectText = 'Pick one';
  @Input()
  fextraClass = '';

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(change: any) {
    this.onTouched();
    this.onChanged(change);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }

  toogleMenuOpen(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  handleOutside($event): void {
    if (!this.dropdownMain.nativeElement.contains($event.targetElement)) {
      this.isMenuOpen = false;
    }
  }

  showValue(): any {
    return this.fData.filter(x => x[this.fDataValueKey] == this.formValue).length > 0
      ? this.fData.filter(x => x[this.fDataValueKey] == this.formValue)[0][this.fDataViewKey]
      : this.fDefaultSelectText;
  }
}

@Component({
  selector: 'datepickerb3',
  template: `
    <div class="form-b3 form-field-b3 datepickerb3">
      <label class="label-b3">{{ fPlaceholder }}:</label>

      <div class="input-container" (click)="toogleShowPicker()">
        <ng2-flatpickr #dateRangePicker [config]="datepickerb3Options" [id]="this.fID"></ng2-flatpickr>
        <div class="show-hide d-flex">
          <image-loader-utils url="calendar" extraClasses="m-auto input-icon"></image-loader-utils>
        </div>
      </div>
      <div class="error-b3" *ngIf="showError">
        {{ fErrorText }}
      </div>
    </div>
  `,
})
export class DatePickerB3 implements ControlValueAccessor {
  @ViewChild('dateRangePicker') dateRangePicker;

  inputControl: ElementRef<HTMLInputElement>;
  startDate = new Date(new Date().getFullYear() - 18, 0, 1);

  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: string;

  touched = false;

  private errorMessages = new Map<string, () => string>();
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  set isAgeControl(value: boolean) {
    this.datepickerb3Options = value ? { ...this.datepickerb3Options, maxDate: subYears(new Date(), 18) } : { ...this.datepickerb3Options };
  }

  showPassword = false;

  datepickerb3Options: FlatpickrOptions = {
    altInputClass: `formType_${this.fInputType}`,
    altInput: true,
    mode: 'single',
    altFormat: 'j-m-Y',
    format: 'j-m-Y',
    defaultDate: new Date(),
    clickOpens: true,
    disableMobile: true,
    onChange: selectedDates => {
      this.handleChange(format(selectedDates[0], 'yyyy-MM-dd'));
    },
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  onTouched = () => {
    this.toogleShowPicker();
  };

  handleChange(change: any) {
    this.onTouched();
    this.onChanged(change);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }

  toogleShowPicker(state = true): void {
    if (state) {
      //this.pickerb3.open();
    } else {
      this.inputControl.nativeElement.blur();
    }
  }
}

@Component({
  selector: 'textareab3',
  template: `
    <div [class]="mainClass + ' ' + extraClass + ' ' + fInputType">
      <label [for]="fID" class="label-b3">{{ fPlaceholder }}</label>

      <div [class]="'input-container ' + fInputType">
        <textarea
          [class]="'formType_' + fInputType"
          [rows]="fTextRows"
          [cols]="fTextCols"
          [id]="fID"
          [name]="fID"
          [required]="isRequired"
          [(ngModel)]="formValue"
          (ngModelChange)="handleChange($event)"
          (click)="onTouched()"
          [disabled]="disabled"></textarea>
      </div>
      <div class="error-b3" *ngIf="showError">
        {{ fErrorText }}
      </div>
    </div>
  `,
})
export class Textareab3 implements ControlValueAccessor {
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: any;

  private errorMessages = new Map<string, () => string>();
  mainClass = 'form-b3 form-field-b3';

  @Input()
  extraClass = '';
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType: 'text' | 'password' | 'number' = 'text';
  @Input()
  fSuffixText = '';
  @Input()
  fTextRows: string;
  @Input()
  fTextCols: string;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(change: any) {
    this.onTouched();
    this.onChanged(change);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }
}
